import Vue from 'vue'
import axios from 'axios'
import config from './config'
import router from '../router'

const baseURL = config.baseUrl;
const http = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type' : 'application/json; charset=UTF-8'
    // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  }
});
http.interceptors.request.use(config => {
  //config是axios配置对象
  //每次发送请求前都会进入此拦截器处理函数，可以在此处统一携带上token，每次请求都会自
  // config.headers['token'] = localStorage.getItem('token');
  // console.log(config)
  config.method === 'post' ? config.data = {...config.data} : config.params = {...config.data}
  config.headers['X-Access-Token'] = localStorage.getItem('token');
  return config

},err => {
  //请求出错的处理函数
  return Promise.reject(err)
})
// 添加响应拦截器
http.interceptors.response.use( (response)=> {
  // 对响应数据做点什么
  if (response.data.code == 401) {
    let returnUrl = "";
    returnUrl = window.location.href.indexOf("returnUrl")!=-1?
                window.location.href.split("returnUrl=")[1]:
                window.location.href.indexOf("#")!=-1?window.location.href.split("#")[1]:"";
    console.log("returnUrl：",returnUrl)
    router.push({path: '/home/home?returnUrl='+returnUrl,query:{share:true}})

     // router.push({path: '/login/login?returnUrl='+returnUrl})
    localStorage.removeItem("token");
    // http://10.10.81.149:8081/#/task/taskDetail?id=81
  }
  return response.data;
},  (error)=> {
  // 对响应错误做点什么
  return Promise.reject(error);
});
export default http



// WEBPACK FOOTER //
// ./src/api/index.js